<template>
  <md-toolbar md-elevation="0" class="md-transparent">
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">
          {{ $route.name }}
    
        </h3>
      </div>
      <div class="md-toolbar-section-end">
        <span v-if="nombreRegional" class="md-title" style="margin-right: 16px;">
          Regional: {{ nombreRegional }}
        </span>
        <md-button class="md-just-icon md-simple md-toolbar-toggle" :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar">
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
export default {
  data() {
    return {
      usuario: JSON.parse(localStorage.getItem("usuario")) || {},
      regionales: [],
    };
  },
  computed: {
    nombreCompleto() {
      return `${this.usuario.nombre || ''} ${this.usuario.apellidos || ''}`.trim();
    },
    nombreRegional() {
      const regional = this.regionales.find(r => r.id == this.usuario.regional_id);
      return regional ? regional.nombre : '';
    }
  },
  async mounted() {
    const token = localStorage.getItem("authToken");
    try {
      const res = await fetch('https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/regional/listar_regionales.php', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (res.ok) {
        this.regionales = await res.json();
      }
    } catch (e) {
      // Manejo de error opcional
    }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
  },
};
</script>

<style lang="css">
@media (min-width: 961px) {
  .md-toolbar-toggle {
    display: none !important;
  }
}
</style>